import React from 'react';
import { withTranslation } from 'react-i18next';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';

class AlertDialog extends React.Component {
  render() {
    const {
      classes,
      t,
      isOpen,
      title,
      children,
      onClose,
    } = this.props;

    return (
      <Dialog
        open={isOpen}
        onClose={onClose}
        fullWidth
        aria-labelledby="alert-form-dialog-title"
        className="alert-dialog"
      >
        <DialogTitle id="alert-form-dialog-title">
          {title}
        </DialogTitle>
        <DialogContent>
          {children}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={onClose}
            className="alert-dialog-close-button"
          >
            {t('Close')}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default withTranslation()(AlertDialog);
